//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "GoodsItem",
  props: {
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};